import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    SmartDevicesData: [],       // Stores smart device data
    lastFetchedSmartDevicesData: [],
    isLoadingSmartDeviceData: true
};

const smartDevicesSlice = createSlice({
    name: "smartDevices",
    initialState,


    reducers: {
        setSmartDevicesCache: (state, action) => {
            const { name, data } = action.payload;
            if (name === "SmartDevicesData") {
                state.SmartDevicesData = data;
            }
            if (name === "lastFetchedSmartDevicesData") {
                state.lastFetchedSmartDevicesData = data;
            }
            state.isLoadingSmartDeviceData = false;
        },
        clearSmartDevices: (state) => {
            state.SmartDevicesData = [];
            state.lastFetchedSmartDevicesData = [];
        },
        SetLoading: (state, action) => {
            state.isLoadingSmartDeviceData = action.payload;
        }
    },
});

export const { setSmartDevicesCache, clearSmartDevices, SetLoading } = smartDevicesSlice.actions;
export default smartDevicesSlice.reducer;
